import { useAuthStore } from '@/stores/authStore';

/**
 * Whether the current member may use the Live Trading V3 Attack hotkeys
 * (W/E). The relay resolves this from traderRules.attackEnabled
 * (fail-closed) and independently requires the same grant — plus an explicit
 * attack size ceiling — on every `__attack` tagged order, so this field is
 * presentation and never authority. Flipping it off is the per-trader W/E
 * kill switch without touching A/D or one-click.
 */
export function useAttackAccess(): boolean {
  return useAuthStore((s) => s.user?.attackAccess ?? false);
}
